var render = function render(_c,_vm){return _c('footer',{staticClass:"the-footer flex-wrap justify-between",class:_vm.classes},[_vm._m(0)])
}
var staticRenderFns = [function (_c,_vm){return _c('span',[_vm._v("To get supports, navigate to "),_c('a',{attrs:{"href":"http://support.fastboy.net","target":"_blank","rel":"nofollow"}},[_vm._v("Support page")]),_vm._v(", Thank you!")])
}]

export { render, staticRenderFns }